import { render, staticRenderFns } from "./BaseCardFooter.vue?vue&type=template&id=03801c62"
import script from "./BaseCardFooter.vue?vue&type=script&lang=js"
export * from "./BaseCardFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports